import { render, staticRenderFns } from "./AttractionEnrichmentPanel.vue?vue&type=template&id=dabe9c20&scoped=true"
import script from "./AttractionEnrichmentPanel.vue?vue&type=script&lang=js"
export * from "./AttractionEnrichmentPanel.vue?vue&type=script&lang=js"
import style0 from "./AttractionEnrichmentPanel.vue?vue&type=style&index=0&id=dabe9c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabe9c20",
  null
  
)

export default component.exports